import { render, staticRenderFns } from "./Operate.vue?vue&type=template&id=5fa2fefa&scoped=true"
import script from "./Operate.vue?vue&type=script&lang=js"
export * from "./Operate.vue?vue&type=script&lang=js"
import style0 from "./Operate.vue?vue&type=style&index=0&id=5fa2fefa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa2fefa",
  null
  
)

export default component.exports